import React, { useState } from 'react';
import '../css/NewCustomerModal.css'; // Assuming you'll create a CSS file for styling

/**
     * Renders the modal for adding a new client.
     * @param {object} props - Component props.
     * @param {boolean} props.isOpen - Whether the modal is open.
     * @param {function(): void} props.onClose - Function to close the modal.
     * @param {string} props.clientName - Current value of client name input.
     * @param {function(React.ChangeEvent<HTMLInputElement>): void} props.onClientNameChange - Handler for client name input change.
     * @param {string} props.travelDestination - Current value of travel destination input.
     * @param {function(React.ChangeEvent<HTMLInputElement>): void} props.onTravelDestinationChange - Handler for travel destination input change.
     * @param {string} props.taskDueDate - Current value of due date input.
     * @param {function(React.ChangeEvent<HTMLInputElement>): void} props.onTaskDueDateChange - Handler for due date input change.
     * @param {function(): void} props.onAddClientTask - Function to add a new client task.
     */
type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
    clientName: string;
    onClientNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    travelDestination: string;
    onTravelDestinationChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    taskDueDate: string;
    onTaskDueDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAddClientTask: () => void;
};



const Modal: React.FC<ModalProps> = ({ isOpen, onClose, clientName, onClientNameChange, travelDestination, onTravelDestinationChange, taskDueDate, onTaskDueDateChange, onAddClientTask }) => {


    const [name, setName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [email, setEmail] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipCode, setZipCode] = useState('');

    const handleSubmit = (e: any) => {
        e.preventDefault();
        // Here you would handle form submission, e.g., send data to an API
        console.log({
            name,
            email,
            month,
            day,
            address,
            city,
            state,
            zipCode,
        });
        alert('Form submit - under construction');
    };

    if (!isOpen) return null;


    return (
        <>
        <div className='login-main-container'> 

        <div className="dashboard_container">
        <div className="modal" onClick={(e) => (e.target instanceof HTMLElement && e.target.classList.contains('modal')) && onClose()}>
            <div className="modal-content">
                <span className="close-button" onClick={onClose}>&times;</span>
                <h2 className="text-2xl font-bold mb-4 text-gray-800">Add New Travel Lead</h2>

                <div className="contact-form-container">
                    <form onSubmit={handleSubmit} className="contact-form">

                        <div className="form-group">
                            <div className="mb-4">
                                <div style={{ display: "flex" }}>
                                    <span><label htmlFor="name">Client Name</label></span>
                                    <span className="required-label"> <span style={{ color: 'red' }}>*</span></span>
                                </div>
                                <input
                                    type="text"
                                    id="name"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="e.g., John Doe"
                                    value={name}
                                    onChange={(e) => {
                                        setName(e.target.value);
                                        onClientNameChange(e);
                                    }}
                                />
                            </div>
                        </div>


                        <div className="form-group">
                            <div style={{ display: "flex" }}>
                                <span><label htmlFor="mobileNo">Mobile Number </label></span>
                                <span className="required-label"> <span style={{ color: 'red' }}>*</span></span>
                            </div>
                            <input
                                type="etxt"
                                id="mobileNo"
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <div style={{ display: "flex" }}>
                                <span style={{ float: "left" }}><label htmlFor="email">Email</label></span>

                            </div>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="form-group birthday-group">
                            <div>
                                <span style={{ float: "left" }}><label>Birthday</label></span>
                            </div>
                            <label>Birthday • Optional</label>
                            <div className="birthday-inputs">
                                <select
                                    id="month"
                                    value={month}
                                    onChange={(e) => setMonth(e.target.value)}
                                >
                                    <option value="">Month</option>
                                    {/* You would populate months dynamically or manually */}
                                    <option value="January">January</option>
                                    <option value="February">February</option>
                                    {/* ... more months */}
                                </select>
                                <select
                                    id="day"
                                    value={day}
                                    onChange={(e) => setDay(e.target.value)}
                                >
                                    <option value="">Day</option>
                                    {/* You would populate days dynamically */}
                                    {Array.from(Array(31).keys()).map(i => (
                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <div style={{ display: "flex" }}>
                                <span style={{ float: "left" }}><label htmlFor="address">Address</label></span>
                            </div>
                            <input
                                type="text"
                                id="address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </div>

                        <div className="form-group">
                            <div style={{ display: "flex" }}>
                                <span style={{ float: "left" }}><label htmlFor="city">City</label></span>
                            </div>
                            <input
                                type="text"
                                id="city"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group half-width">
                                <div style={{ display: "flex" }}>
                                    <span style={{ float: "left" }}><label htmlFor="state">State</label></span>
                                </div>
                                <input
                                    type="text"
                                    id="state"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}
                                />
                            </div>
                            <div className="form-group half-width">
                                <div style={{ display: "flex" }}>
                                    <span style={{ float: "left" }}><label htmlFor="zipCode">ZIP/postal code</label></span>
                                </div>
                                <input
                                    type="text"
                                    id="zipCode"
                                    value={zipCode}
                                    onChange={(e) => setZipCode(e.target.value)}
                                />
                            </div>
                        </div>




                        <div className="mb-4">
                            <label htmlFor="travelDestination" className="block text-gray-700 text-sm font-bold mb-2">Travel Destination:</label>
                            <input
                                type="text"
                                id="travelDestination"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                placeholder="e.g., Paris, France"
                                value={travelDestination}
                                onChange={onTravelDestinationChange}
                            />
                        </div>
                        <div className="mb-6">
                            <label htmlFor="taskDueDate" className="block text-gray-700 text-sm font-bold mb-2">Due Date:</label>
                            <input
                                type="date"
                                id="taskDueDate"
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                value={taskDueDate}
                                onChange={onTaskDueDateChange}
                            />
                        </div>
                        <button
                            onClick={onAddClientTask}
                            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
                        >
                            Add Client Task
                        </button>

                    </form>
                </div>


            </div>
        </div>
        </div>

                    </div>
        </>
    );
};


export default Modal;